import React from 'react';

const SurvivabilityGauge = ({ survivability }) => {
  if (!survivability) return null;

  const { score, label } = survivability;
  
  // Color based on score
  const getColor = (s) => {
    if (s >= 70) return '#10b981';
    if (s >= 40) return '#fbbf24';
    return '#ef4444';
  };

  const color = getColor(score);

  return (
    <div style={{
      background: 'rgba(255,255,255,0.96)',
      borderRadius: 12,
      padding: 20,
      border: '1px solid rgba(0,0,0,0.08)'
    }}>
      <h4 style={{ margin: '0 0 16px 0', fontSize: 16, fontWeight: 700, color: '#1f2937' }}>
         Survivability
      </h4>
      
      {/* Gauge */}
      <div style={{ marginBottom: 12 }}>
        <div style={{
          height: 24,
          background: '#f3f4f6',
          borderRadius: 12,
          overflow: 'hidden',
          position: 'relative'
        }}>
          <div style={{
            height: '100%',
            width: `${score}%`,
            background: color,
            transition: 'width 0.5s ease',
            borderRadius: 12
          }} />
        </div>
      </div>

      {/* Score & Label */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 28, fontWeight: 800, color }}>
          {score}/100
        </span>
        <span style={{
          padding: '4px 12px',
          background: `${color}20`,
          color,
          borderRadius: 6,
          fontSize: 13,
          fontWeight: 700
        }}>
          {label}
        </span>
      </div>

      <p style={{ fontSize: 12, color: '#6b7280', margin: '8px 0 0 0' }}>
        {survivability.note || 'Account survival probability'}
      </p>
    </div>
  );
};

export default SurvivabilityGauge;
